import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import button from '@/components/button'

export default function(h) {
  let icon = icons.favorite_outline
  let color
  if (this.isFavorite) {
    icon = icons.favorite
    color = Colors.error
  }

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon,
        color,
        tooltip: this.getTranslate(`${this.service}.tooltips.favorites`)
      },
      on: {
        click: this.clickHandler
      }
    }
  )
}
